import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import {
    IAddLocationPayload,
    IAppHistoryLocation,
    IOpenLocationPayload,
    ISetLocationOriginParamsPayload,
    TLocationPlatform
} from "./location.t";
import { LOGOUT_SUCCESS } from "../Login/loginConstants";

export interface ILocationState {
    isInited: boolean;
    originPathname: string;
    originSearch: string;
    platform: TLocationPlatform | undefined;
    prevLocation: IAppHistoryLocation;
}

const initialState: ILocationState = {
    isInited: false,
    originPathname: '',
    originSearch: '',
    platform: undefined,
    prevLocation: {} as IAppHistoryLocation,
};

export const locationSlice = createSlice({
    name: 'location',
    initialState,
    reducers: {
        setOriginParamsAction: (state, action: PayloadAction<ISetLocationOriginParamsPayload>) => {
            if (action.payload.originPathname !== undefined) {
                state.originPathname = action.payload.originPathname;
            }
            if (action.payload.originSearch !== undefined) {
                state.originSearch = action.payload.originSearch;
            }
        },
        setPrevLocationAction: (state, action: PayloadAction<IAppHistoryLocation>) => {
            state.prevLocation = action.payload;
        },
        openOriginPageAction: (state, action: PayloadAction) => {},
        updatePlatformAction: (state, action: PayloadAction<TLocationPlatform>) => {
            state.platform = action.payload;
        },

        setIsInitedAction: (state, action: PayloadAction<boolean>) => {
            state.isInited = action.payload;
        },

        openLocationAction: (state, action: PayloadAction<IOpenLocationPayload>) => {},
        addLocationAction: (state, action: PayloadAction<IAddLocationPayload>) => {},
    },
    extraReducers: (builder) => {
        builder.addCase(LOGOUT_SUCCESS, (state) => {
            return {
                ...initialState,
                isInited: state.isInited,
                platform: state.platform,
                prevLocation: state.prevLocation,
            }
        })
    },
});

export default locationSlice.reducer;
